import React, { useState, forwardRef, useImperativeHandle } from 'react';

import { Box } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import { green } from '@material-ui/core/colors';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogActions from '@material-ui/core/DialogActions';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import Slide from '@material-ui/core/Slide';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import { useSnackbar } from 'notistack';

import { getListAllAPI, api } from '../../../services';
import { STATUS_ATIVO } from '../../../utils';

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: 'white',
  },
});

const Transition = React.forwardRef((props, ref) => (
  <Slide direction="up" ref={ref} {...props} />
));

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6" style={{ fontWeight: 'bold' }}>
        {children}
      </Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

const useStyles = makeStyles((theme) => ({
  rootDialogo: {
    borderRadius: '25px',
  },
  btnAtions: {
    borderRadius: '25px',
    width: '150px',
  },
  btnAtionsDisabled: {
    borderRadius: '25px',
    width: '150px',
  },
  wrapper: {
    margin: theme.spacing(1),
    position: 'relative',
  },
  buttonProgress: {
    color: green[500],
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
}));

const DialogoCategoriaTransacao = forwardRef(
  ({ handleClose, cor = 'green' }, ref) => {
    const [open, setOpen] = useState(false);
    const { enqueueSnackbar } = useSnackbar();
    const [id, setId] = useState(-1);
    const [carregando, setCarregando] = useState(false);
    const [dados, setDados] = useState({
      status: false,
      nome: '',
      cst: '',
      descricao: '',
      codigo: '',
    });

    const classes = useStyles();

    const handleCloseDialog = () => {
      setOpen(false);
      handleClose();
    };

    async function getDataResource(id) {
      try {
        const data = await getListAllAPI(
          'tabela-c-class-trib',
          ['id', 'asc'],
          { id: [id] },
          [],
        );
        if (data.data.length > 0) {
          setDados({
            status: data.data[0].status === STATUS_ATIVO ? true : false,
            nome: data.data[0].nome,
            cst: data.data[0].cst,
            descricao: data.data[0].descricao,
            codigo: data.data[0].c_class_trib,
          });
          setCarregando(false);
        } else {
          throw 'Este CClassTrib não existe!';
        }
      } catch (erros) {
        enqueueSnackbar(`${erros}`, {
          variant: 'error',
        });
        handleCloseDialog();
      }
    }

    async function handleSalvar() {
      try {
        if (id <= 0) {
          enqueueSnackbar('Nenhum CClassTrib aqui!!!', {
            variant: 'error',
          });
        } else {
          if (dados.status) {
            const response = await api.put(
              `/tabela-c-class-trib/status/inativar/${id}`,
            );

            const { status, message } = response.data;

            if (status) {
              setCarregando(false);
              enqueueSnackbar(`CClassTrib com status alterado com sucesso!`, {
                variant: 'success',
              });
            } else {
              enqueueSnackbar(message, {
                variant: 'error',
              });
            }
          } else {
            const response = await api.put(
              `/tabela-c-class-trib/status/ativar/${id}`,
            );

            const { status, message } = response.data;

            if (status) {
              setCarregando(false);
              enqueueSnackbar(`CClassTrib com status alterado com sucesso!`, {
                variant: 'success',
              });
            } else {
              enqueueSnackbar(message, {
                variant: 'error',
              });
            }
          }
        }
        handleCloseDialog();
      } catch (erros) {
        enqueueSnackbar('Erro ao alterar o status deste CClassTrib!', {
          variant: 'error',
        });
        handleCloseDialog();
      }
    }

    useImperativeHandle(ref, () => ({
      handleOpen(id) {
        setCarregando(true);
        getDataResource(id);
        setOpen(true);
        setId(id);
      },
    }));

    return (
      <div>
        <Dialog
          open={open}
          aria-labelledby="form-dialog-title"
          classes={{ paper: classes.rootDialogo }}
          className={classes.rootDialogo}
          fullWidth
          maxWidth="xs"
          TransitionComponent={Transition}
          keepMounted
        >
          <DialogTitle
            id="form-dialog-title"
            onClose={handleCloseDialog}
            style={{
              backgroundColor: dados.status ? '#f44336' : '#4caf50',
              color: 'white',
            }}
          >
            {dados.status ? 'Inativar CClassTrib' : 'Ativar CClassTrib'}
          </DialogTitle>
          <DialogContent
            style={{
              padding: '0px 36px 20px',
              margin: '0',
            }}
          >
            {carregando ? (
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <CircularProgress />
              </div>
            ) : (
              <>
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'flex-start',
                    fontSize: '20px',
                    flexDirection: 'column',
                    gap: '15px',
                  }}
                >
                  <div>
                    <span
                      style={{
                        fontWeight: 'bolder',
                      }}
                    >
                      Código:{' '}
                    </span>
                    <span>{dados.codigo}</span>
                  </div>
                  <div>
                    <span
                      style={{
                        fontWeight: 'bolder',
                      }}
                    >
                      CST:{' '}
                    </span>
                    <span>{dados.cst}</span>
                  </div>
                  <div>
                    <span
                      style={{
                        fontWeight: 'bolder',
                      }}
                    >
                      Nome:{' '}
                    </span>
                    <span>{dados.nome}</span>
                  </div>
                  <div>
                    <span
                      style={{
                        fontWeight: 'bolder',
                      }}
                    >
                      Descrição:{' '}
                    </span>
                    <span>{dados.descricao}</span>
                  </div>
                </div>
              </>
            )}
          </DialogContent>
          <DialogActions
            style={{
              padding: '32px 36px 20px',
              margin: '0',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <Button
              onClick={handleCloseDialog}
              classes={{
                root: classes.btnAtions,
                disabled: classes.btnAtionsDisabled,
              }}
              variant="outlined"
              color="primary"
            >
              Cancelar
            </Button>
            <Box>
              <div className={classes.wrapper}>
                <Button
                  onClick={handleSalvar}
                  classes={{
                    root: classes.btnAtions,
                    disabled: classes.btnAtionsDisabled,
                  }}
                  variant="contained"
                  color="primary"
                  disabled={carregando}
                >
                  Confirmar
                </Button>
                {carregando && (
                  <CircularProgress
                    size={24}
                    className={classes.buttonProgress}
                  />
                )}
              </div>
            </Box>
          </DialogActions>
        </Dialog>
      </div>
    );
  },
);

export default DialogoCategoriaTransacao;
